import { getCountries } from 'helpers/json';

export const COUNTRIES = getCountries();

export const REGISTRATION_VALUES_USER = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
};

export const REGISTRATION_VALUES_PARTNER = {
  phone: '',
  businessName: '',
  url: '',
  country: '',
  entity: true,
};

export const REGISTRATION_META = {
  user: {
    title: 'Get Started – Siteplus Website Builder',
    description:
      'Siteplus is the simplest platform you need to build your own website.',
  },
  partner: {
    title: 'Register to the Siteplus Reseller Program',
    description: 'Engage your customers with your own website builder.',
  },
};

export const REGISTRATION_TYPE = 'partner';
